import React from 'react'

export default class Logout extends React.Component {
  constructor (props) {
    super(props)

    this.ref = React.createRef()
  }

  componentDidMount () {
    this.ref.current.submit()
  }

  render () {
    return <form ref={this.ref} action="/logout" method="post" className="hidden" />
  }
}
